import { Suspense } from 'react';

import { ComponentLoaderProps } from './ComponentLoader.types';
import GettingDataSpinner from '../getting-data-spinner';

export default function ComponentLoader({ children }: ComponentLoaderProps) {
  return <Suspense fallback={<GettingDataSpinner hideMessage />}>{children}</Suspense>;
}
